
import HttpErrorResponseModel from '../models/HttpErrorResponseModel';
import { AxiosResponse } from 'axios';
import * as HttpUtility from '../utilities/HttpUtility'
import IStore from '../models/IStore';
import {IConstructor} from '../models/IConstructor';

type FlattenIfArray<T> = T extends (infer R)[] ? R : T;
type SingleItemOrArray<T> = T extends [] ? T[] : T;

export async function getToModel<T>(
  state: IStore,
  Model: IConstructor<FlattenIfArray<T>>,
  endpoint: string,
  params?: any,
  config?: any
): Promise<SingleItemOrArray<T> | HttpErrorResponseModel> {
  const response: AxiosResponse | HttpErrorResponseModel = await HttpUtility.get(state, endpoint, params, config);

  return _restModelCreator<T>(Model, response);
}

export async function postToModel<T>(
  state: IStore,
  Model: IConstructor<FlattenIfArray<T>>,
  endpoint: string,
  data?: any
): Promise<SingleItemOrArray<T> | HttpErrorResponseModel> {
  const response: AxiosResponse | HttpErrorResponseModel = await HttpUtility.post(state, endpoint, data);

  return _restModelCreator<T>(Model, response);
}

export async function patchToModel<T>(
  state: IStore,
  Model: IConstructor<FlattenIfArray<T>>,
  endpoint: string,
  data?: any
): Promise<SingleItemOrArray<T> | HttpErrorResponseModel> {
  const response: AxiosResponse | HttpErrorResponseModel = await HttpUtility.patch(state, endpoint, data);
  return _restModelCreator<T>(Model, response);
}

export async function putToModel<T>(
  state: IStore,
  Model: IConstructor<FlattenIfArray<T>>,
  endpoint: string,
  data?: any
): Promise<SingleItemOrArray<T> | HttpErrorResponseModel> {
  const response: AxiosResponse | HttpErrorResponseModel = await HttpUtility.put(state, endpoint, data);
  return _restModelCreator<T>(Model, response);
}

export async function deleteToModel<T>(
  state: IStore,
  Model: IConstructor<FlattenIfArray<T>>,
  endpoint: string
): Promise<SingleItemOrArray<T> | HttpErrorResponseModel> {
  const response: AxiosResponse | HttpErrorResponseModel = await HttpUtility.del(state, endpoint);

  return _restModelCreator<T>(Model, response);
}

export async function getToModelNoAuth<T>(
  state: IStore,
  Model: IConstructor<FlattenIfArray<T>>,
  endpoint: string,
  params?: any,
  config?: any
): Promise<SingleItemOrArray<T> | HttpErrorResponseModel> {
  const response: AxiosResponse | HttpErrorResponseModel = await HttpUtility.getNoAuth(state, endpoint, params, config);

  return _restModelCreator<T>(Model, response);
}

function _restModelCreator<T>(
  Model: IConstructor<FlattenIfArray<T>>,
  response: AxiosResponse | HttpErrorResponseModel
): SingleItemOrArray<T> | HttpErrorResponseModel {
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return !Array.isArray(response.data)
    ? (new Model((response.data === '') ? {} : response.data) as SingleItemOrArray<T>)
    : (response.data.map((json: any) => new Model(json)) as SingleItemOrArray<T>);
}

